module.exports = __webpack_public_path__ + "odinstatic/media/pod.ba954328.svg";